import { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { getAdminUser, getAdminToken, canAccessAdminPanel } from '../utils/auth';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = getAdminToken();
    const user = getAdminUser();

    // Redirect to login if not authenticated
    if (!token || !user || !canAccessAdminPanel(user)) {
      navigate('/admin/login');
      return;
    }

    // Redirect non-admins away from admin panel
    if (location.pathname.startsWith('/admin') && !canAccessAdminPanel(user)) {
      navigate('/');
      return;
    }
  }, [navigate, location]);

  const user = getAdminUser();

  return (
    <div className="min-h-screen bg-gray-100">
      <Header user={user} onMenuToggle={() => setSidebarOpen(!sidebarOpen)} />

      <div className="pt-16 min-h-[calc(100vh-4rem)]">
        <Sidebar 
          user={user} 
          isOpen={sidebarOpen} 
          onClose={() => setSidebarOpen(false)} 
        />

        {/* Main Content */}
        <div className="lg:ml-64">
          <main className="h-[calc(100vh-4rem)] overflow-y-auto p-6">
            <div className="w-full mx-auto">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
